export const PROJECTS_FEATURES = {
  moduleKey: 'projects',
  features: ['projects.view', 'projects.manage', 'projects.tasks'] as const,
  featureMeta: {
    'projects.view': {
      name: 'Projects',
      translations: { name: { de: 'Projekte', en: 'Projects', fr: 'Projets', it: 'Progetti' } },
    },
    'projects.manage': {
      name: 'Manage projects',
      translations: { name: { de: 'Projekte verwalten', en: 'Manage projects', fr: 'Gérer les projets', it: 'Gestire i progetti' } },
    },
    'projects.tasks': {
      name: 'Project tasks',
      translations: { name: { de: 'Projektaufgaben', en: 'Project tasks', fr: 'Tâches de projet', it: 'Attività dei progetti' } },
    },
  },
} as const;
